document.addEventListener('DOMContentLoaded', function () {
  const taxToggleCheckbox = document.getElementById('tax-toggle-checkbox');
  const taxToggleText = document.querySelector('.tax-toggle-text');
  const VAT_RATE = typeof window.ShopTaxRate !== 'undefined' ? parseFloat(window.ShopTaxRate) : 0.2;
  const currencySymbol = window.ShopCurrency?.symbol || '£';

  function parseLocalePrice(raw) {
    const cleaned = raw.replace(/[^\d.,]/g, '').trim();
    if (cleaned.includes(',') && cleaned.match(/,\d{2}$/)) {
      return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    }
    return parseFloat(cleaned.replace(/,/g, ''));
  }

  function applyToggleToAll() {
    const priceWrappers = document.querySelectorAll('.js-tax-toggle');
    const showTax = localStorage.getItem('pricePreference') === 'withTax';

    // Toggle for regular product prices
    priceWrappers.forEach(wrapper => {
      const isTaxable = wrapper.dataset.taxable === 'true';
      if (!isTaxable) {
        wrapper.classList.remove('tax-included');
        return;
      }
      wrapper.classList.toggle('tax-included', showTax);
    });

    applyToggleToGloboCards(showTax);
    applyToggleToAddons(showTax);
    applyToggleToLazerPrices(showTax);


    if (taxToggleCheckbox) taxToggleCheckbox.checked = showTax;
    if (taxToggleText) taxToggleText.textContent = showTax ? 'Incl. VAT' : 'Excl. VAT';
  }

  function handleToggleChange(e) {
    const showTax = e.target.checked;
    localStorage.setItem('pricePreference', showTax ? 'withTax' : 'withoutTax');
    applyToggleToAll();
  }

function applyToggleToGloboCards(showTax) {
  document.querySelectorAll('.spf-product-card').forEach(card => {
    const salePriceEl = card.querySelector('.spf-product-card__saleprice');
    const oldPriceEl = card.querySelector('.spf-product-card__oldprice');
    const standardPriceEl = card.querySelector('.spf-product-card__price');
    const select = card.querySelector('.spf-product__variants');

    let handled = false;

    // VARIANT-BASED PRICING
    if (select && select.options.length > 0) {
      const selectedOption = select.options[select.selectedIndex];
      const exVAT = parseLocalePrice(selectedOption?.dataset?.price || '0');
      const compareAtRaw =
        selectedOption?.dataset?.compareAtPrice ||
        selectedOption?.dataset?.compare_at_price ||
        selectedOption?.dataset?.compareAt ||
        '';

      const compareAt = parseLocalePrice(compareAtRaw);

      // If compare_at exists and is greater than price, treat it as a sale
      if (!isNaN(compareAt) && compareAt > exVAT) {
        if (salePriceEl && !salePriceEl.dataset.originalPrice) {
          salePriceEl.dataset.originalPrice = exVAT.toFixed(2);
        }

        if (oldPriceEl && !oldPriceEl.dataset.originalPrice) {
          oldPriceEl.dataset.originalPrice = compareAt.toFixed(2);
        }

        if (salePriceEl && salePriceEl.dataset.originalPrice) {
          const base = parseFloat(salePriceEl.dataset.originalPrice);
          const inc = base * (1 + VAT_RATE);
          salePriceEl.textContent = showTax
            ? `${currencySymbol}${inc.toFixed(2)}`
            : `${currencySymbol}${base.toFixed(2)}`;
        }

        if (oldPriceEl && oldPriceEl.dataset.originalPrice) {
          const base = parseFloat(oldPriceEl.dataset.originalPrice);
          const inc = base * (1 + VAT_RATE);
          oldPriceEl.textContent = showTax
            ? `${currencySymbol}${inc.toFixed(2)}`
            : `${currencySymbol}${base.toFixed(2)}`;
        }

        handled = true;
      }

      // If no compare_at price, update standard full price element
      if (!handled && standardPriceEl && !standardPriceEl.dataset.originalPrice) {
        standardPriceEl.dataset.originalPrice = exVAT.toFixed(2);
      }

      if (!handled && standardPriceEl && standardPriceEl.dataset.originalPrice) {
        const base = parseFloat(standardPriceEl.dataset.originalPrice);
        const inc = base * (1 + VAT_RATE);
        standardPriceEl.textContent = showTax
          ? `${currencySymbol}${inc.toFixed(2)}`
          : `${currencySymbol}${base.toFixed(2)}`;
      }

      return; // we're done if variant-based logic is applied
    }

    // STATIC SALE PRICE
    if (salePriceEl && !salePriceEl.dataset.originalPrice) {
      const raw = salePriceEl.textContent;
      const exVAT = parseLocalePrice(raw);
      if (!isNaN(exVAT)) {
        salePriceEl.dataset.originalPrice = exVAT.toFixed(2);
      }
    }

    if (salePriceEl && salePriceEl.dataset.originalPrice) {
      const base = parseFloat(salePriceEl.dataset.originalPrice);
      const inc = base * (1 + VAT_RATE);
      salePriceEl.textContent = showTax
        ? `${currencySymbol}${inc.toFixed(2)}`
        : `${currencySymbol}${base.toFixed(2)}`;
    }

    // STATIC OLD PRICE
    if (oldPriceEl && !oldPriceEl.dataset.originalPrice) {
      const raw = oldPriceEl.textContent;
      const exVAT = parseLocalePrice(raw);
      if (!isNaN(exVAT)) {
        oldPriceEl.dataset.originalPrice = exVAT.toFixed(2);
      }
    }

    if (oldPriceEl && oldPriceEl.dataset.originalPrice) {
      const base = parseFloat(oldPriceEl.dataset.originalPrice);
      const inc = base * (1 + VAT_RATE);
      oldPriceEl.textContent = showTax
        ? `${currencySymbol}${inc.toFixed(2)}`
        : `${currencySymbol}${base.toFixed(2)}`;
    }

    // STATIC FULL PRICE
    if (
      standardPriceEl &&
      !standardPriceEl.classList.contains('spf-product-card__saleprice') &&
      !standardPriceEl.dataset.originalPrice
    ) {
      const raw = standardPriceEl.textContent;
      const exVAT = parseLocalePrice(raw);
      if (!isNaN(exVAT)) {
        standardPriceEl.dataset.originalPrice = exVAT.toFixed(2);
      }
    }

    if (
      standardPriceEl &&
      standardPriceEl.dataset.originalPrice &&
      !standardPriceEl.classList.contains('spf-product-card__saleprice')
    ) {
      const base = parseFloat(standardPriceEl.dataset.originalPrice);
      const inc = base * (1 + VAT_RATE);
      standardPriceEl.textContent = showTax
        ? `${currencySymbol}${inc.toFixed(2)}`
        : `${currencySymbol}${base.toFixed(2)}`;
    }
  });
}



  function applyToggleToAddons(showTax) {
    document.querySelectorAll('.addon-product-wrapper').forEach(wrapper => {
      const priceEl = wrapper.querySelector('.addon-price');
      const qty = parseInt(wrapper.dataset.addonQty || 1, 10);
      const basePrice = parseFloat(wrapper.dataset.addonPrice || 0);
      const parentSection = wrapper.closest('.product-addons');
      const taxRate = parentSection ? parseFloat(parentSection.dataset.taxRate || VAT_RATE) : VAT_RATE;

      if (!priceEl || isNaN(basePrice)) return;

      const total = basePrice * qty;
      const taxed = total * (1 + taxRate);

      priceEl.textContent = showTax
        ? `${currencySymbol}${taxed.toFixed(2)}`
        : `${currencySymbol}${total.toFixed(2)}`;
    });
  }

  function applyToggleToLazerPrices(showTax) {
    document.querySelectorAll('.ai-lazer-price-value').forEach(priceEl => {
      const rawBase = priceEl.dataset.basePrice;
      const baseCents = Number(rawBase);
      const isTaxable = priceEl.dataset.taxable === 'true';
      const currency = priceEl.dataset.currency;

      if (!rawBase || !Number.isFinite(baseCents) || !currency) return;

      if (typeof priceEl.dataset.originalHtml === 'undefined') {
        priceEl.dataset.originalHtml = priceEl.innerHTML;
      }

      if (!showTax || !isTaxable) {
        const originalHtml = priceEl.dataset.originalHtml;

        if (priceEl.innerHTML !== originalHtml) {
          priceEl.innerHTML = originalHtml;
        }
        return;
      }

      if (!Number.isFinite(VAT_RATE)) return;

      const inclusivePrice = (baseCents / 100) * (1 + VAT_RATE);

      const formatted = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(inclusivePrice);

      if (priceEl.textContent !== formatted) {
        priceEl.textContent = formatted;
      }
    });
  }


  // Initial load
  applyToggleToAll();

  if (taxToggleCheckbox) {
    taxToggleCheckbox.addEventListener('change', handleToggleChange);
  }

  // Observe for AJAX/Globo content updates
  let throttleTimeout;
  const observerCallback = () => {
    if (throttleTimeout) return;
    throttleTimeout = setTimeout(() => {
      applyToggleToAll();
      throttleTimeout = null;
    }, 200);
  };


  const observer = new MutationObserver(observerCallback);
  const targetNode = document.querySelector('.main-content') || document.body;

  setTimeout(() => {
    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
      });
    }
  }, 500);
});
